import { ErrorMessage, useField } from "formik";
import React, { useState } from "react";
import { InputGroup } from "react-bootstrap";
import useFetch from "../../../hooks/useFetch";
import request from "../../../request/request";
import ReactSelect from "../../ReactSelect/ReactSelect";

const SelectCountry = ({ ...props }) => {
	const { result: countryList, setRefresh } = useFetch(() =>
		request.getAll("country"),
	);
	const [isModalOpen, setModalOpen] = useState(false);
	const [field, meta, helper] = useField(props);

	// const initialValues = {
	//     name: '',
	//     info: '',
	//     status: 1,
	// };
	// const handleFormSubmit = async (formData) => {
	//     await request.create('department', formData, () => {
	//         setModalOpen(false);
	//         setRefresh((prevState) => !prevState);
	//     });
	// };

	// console.log(countryList);

	return (
		<>
			<InputGroup>
				<ReactSelect
					data={countryList}
					value={field?.value}
					valueName="id"
					labelName="name"
					onChange={(val) => helper.setValue(val)}
				/>

				{/* <ReactTooltip title='Add New Department'> */}
				{/*    <Button variant='teal' onClick={() => setModalOpen(true)}> */}
				{/*        <FaPlus /> */}
				{/*    </Button> */}
				{/* </ReactTooltip> */}
			</InputGroup>

			<ErrorMessage name={props?.name} component="p" className="error" />

			{/* {isModalOpen && ( */}
			{/*    <ModalLayout */}
			{/*        title='Add Department' */}
			{/*        isOpen={isModalOpen} */}
			{/*        onClose={() => setModalOpen(false)} */}
			{/*    > */}
			{/*        <CrudFormLayout initialValues={initialValues} apiHandler={handleFormSubmit}> */}
			{/*            <NameInfoForm firstFieldName='name' /> */}
			{/*        </CrudFormLayout> */}
			{/*    </ModalLayout> */}
			{/* )} */}
		</>
	);
};

export default SelectCountry;
